import React from 'react'
import { Modal, Select, InputNumber, Input, Form } from 'antd'

const FormItem = Form.Item

// Small popup to edit a single field (physicalCondition | qty | parentAssetCode)
// of one Pre Verification asset detail. Pre-filled with the current value.
class EditFieldModal extends React.Component {
  state = {
    value: undefined,
  }

  componentDidUpdate (prevProps) {
    // when the modal is (re)opened, seed the input with the current value
    if (this.props.visible && !prevProps.visible) {
      this.setState({ value: this.props.currentValue })
    }
  }

  handleOk = () => {
    const { field } = this.props
    let value = this.state.value

    if (field === 'qty') {
      const num = parseInt(value, 10)
      if (isNaN(num) || num < 1) {
        return Modal.error({ title: 'Invalid quantity', content: 'Quantity must be a number greater than 0.' })
      }
      value = num
    }
    if (field === 'physicalCondition' && !value) {
      return Modal.error({ title: 'Physical Condition required', content: 'Please select a physical condition.' })
    }

    this.props.onSave(field, value)
  }

  renderField () {
    const { field, conditionOptions } = this.props
    const { value } = this.state

    if (field === 'physicalCondition') {
      return (
        <Select
          showSearch
          allowClear
          style={{ width: '100%' }}
          value={value}
          placeholder='Please Select Physical Condition'
          onChange={(v) => this.setState({ value: v })}
          filterOption={(input, option) =>
            (option.props.children + '').toLowerCase().indexOf((input + '').toLowerCase()) >= 0
          }
        >
          {(conditionOptions || []).map((option) => (
            <Select.Option key={option._id} value={option._id}>{option.name}</Select.Option>
          ))}
        </Select>
      )
    }

    if (field === 'qty') {
      return (
        <InputNumber
          min={1}
          style={{ width: '100%' }}
          value={value}
          onChange={(v) => this.setState({ value: v })}
        />
      )
    }

    // parentAssetCode
    return (
      <Input
        style={{ width: '100%' }}
        value={value}
        placeholder='Parent Asset Code'
        onChange={(e) => this.setState({ value: e.target.value })}
        autoComplete='off'
      />
    )
  }

  render () {
    const { visible, title, onCancel, confirmLoading } = this.props
    return (
      <Modal
        title={title || 'Edit'}
        visible={visible}
        onOk={this.handleOk}
        onCancel={onCancel}
        okText='Save'
        confirmLoading={confirmLoading}
        destroyOnClose
      >
        <Form layout='vertical'>
          <FormItem label={title}>
            {this.renderField()}
          </FormItem>
        </Form>
      </Modal>
    )
  }
}

export default EditFieldModal
